"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const integrationsService = {
  getIngetrations: function (options) {
    return api.get("/Integrations", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getIngetrationsTypes: function () {
    return api.get("/Integrations/Types", WithToken.headersToken({}, configuration.cookieName));
  },
  createIngetration: function (options) {
    return api.post("/Integrations", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteIngetration: function (options) {
    return api.delete("/Integrations/" + options.id, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default integrationsService;
